// components/notDragable.component.jsx
import React from "react";

/**
 * Props:
 * - defaultPos?: { x:number, y:number }   // used when centerScreen is false (default)
 * - centerScreen?: boolean                 // when true, centers in viewport
 * - title, width, onAddFunction, onAddText, addNote, children  (unchanged)
 */
const NotDragable = ({
  defaultPos = { x: 100, y: 100 },
  centerScreen = false,
  title = "",
  width = 700,
  children,
  onAddFunction = null,
  onAddText = "+",
  addNote,
}) => {
  // Base box styles (identical look)
  const base = {
    zIndex: 500,
    minWidth: width,
    maxWidth: width,
    border: "2px solid navy",
    borderRadius: 8,
    backgroundColor: "var(--bs-body-bg)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  };

  // Positioning: center vs. explicit coords
  const posStyles = centerScreen
    ? {
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }
    : {
        position: "absolute",
        left: defaultPos.x,
        top: defaultPos.y,
      };

  return (
    <div style={{ ...base, ...posStyles }} className="card shadow-sm">
      <div
        className="card-header d-flex align-items-center p-0"
        style={{ height: 40, cursor: "default" }}
        title={centerScreen ? "Centered" : "Fixed"}
      >
        <div className="d-flex align-items-center col-48 p-2" style={{ backgroundColor: "rgba(178, 182, 182, 0.1)" }}>
          <div className="text-primary flex-grow-1 text-center fs-7">{title}</div>

          {addNote !== "-" && (
            <button
              className="btn btn-sm btn-outline-success"
              style={{ marginRight: "5px", height: 30, padding: "0 8px" }}
              onClick={(e) => {
                e.stopPropagation();
                onAddFunction && onAddFunction();
              }}
              aria-label="Add"
              title={addNote}
            >
              {onAddText}
            </button>
          )}
        </div>
      </div>

      {children && <div className="card-body p-2">{children}</div>}
    </div>
  );
};

export default NotDragable;
